import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VConsole from 'vconsole'

// vConsole 调试工具
// 开发环境自动启用，生产环境通过 URL 参数 isDev=true 或 debug=true 启用
// 如果是在开发模式下,从路由参数获取 lastname  http://localhost:8080/#/?mode=dev&lastname=30279
// 支持 hash 路由： https://your-domain.com/#/?isDev=true
// 支持普通路由： https://your-domain.com/?debug=true
const fullUrl = location.search + location.hash
const isDebug = process.env.NODE_ENV === 'development' || 
                fullUrl.includes('debug=true') ||
                fullUrl.includes('isDev=true')
if (isDebug) {
  new VConsole()
  console.log('[vConsole] 调试模式已启用')
}

Vue.config.productionTip = false

// 企业微信全局配置
Vue.prototype.$wecomConfig = {
  //  企业ID - 在企业微信管理后台 > 我的企业 > 企业信息 中查看
  // corpId: 'ww9fc58648d36cd772', // 仓库狗
  // corpId: 'wwc9d4af920d011b75', // 影子
  // corpId: 'ww142f9e739a4b1e23', // 海狸
  //  corpId: 'wwa7fffee01ae20f2e', // 省心
  //  corpId: 'wwef962e5b54d48eed', // 太田
   corpId: 'ww200da80c4f5bca02', // 顺集
  // 仓库狗 应用AgentId - 在企业微信管理后台 > 应用管理 > 自建应用 中查看
  // agentId: '1000002', // 仓库狗
  // agentId: '1000023', // 影子
  // agentId: '1000009', // 海狸
  // agentId: '1000002', // 省心
  // agentId: '1000026', // 太田
  agentId: '1000007', // 顺集
  // 仓库狗 后端接口地址
  // signatureApi: 'https://api.ckg.cangkugou.cn', // 仓库狗
  // signatureApi: 'https://api2.yingzi.cangkugou.cn', // 影子
  // signatureApi: 'https://api.haili.cangkugou.cn', // 海狸
  //  signatureApi: 'https://api.szsx.cangkugou.xin', // 省心
  //  signatureApi: 'https://api.taitian.cangkugou.xin', // 太田
   signatureApi: 'https://api.sjzy.cangkugou.xin', // 顺集
  // signatureApi: 'http://localhost:8081',
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
